module.exports = __webpack_public_path__ + "static/media/universityofreading.356f4ab6.png";